import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../GradesPage.module.css";

const EmptyState = ({ icon, title, message }) => {
	return (
		<div className={styles.emptyState}>
			<FontAwesomeIcon icon={icon} className={styles.emptyIcon} />
			<h3>{title}</h3>
			<p>{message}</p>
		</div>
	);
};

export default EmptyState;
